/*******************************************************************
* PAGE        : commonImages
* REMARKS     : Comman Images get form src Assets folder
* CREATED ON  : 30-12-2025
* AUTHOR      : Bamroliya.Paras
* MODIFY      : Bamroliya.Paras
* MODIFY ON   : 13-02-2026
********************************************************************/

const commonImages = {
    companylogo: require('../assets/cmlogo.png'),


    cmLogo: require('../assets/cmlogo.png'),
    nutecIcon: require('../assets/nutecicon.png'),
    cmnewlogo: require('../assets/cmnewlogo.png'),
    cmexpress: require('../assets/cmexpress.png'),
    errorboundarydasktop: require('../assets/errorboundarydasktop.png'),
    mapImage: require('../assets/mapimage.png'),
    loginPicture: require('../assets/loginpicture.png'),
    loginLeftBackground: require('../assets/loginleftbackground.jpg'),
    makeInIndia: require('../assets/makeinindia.png'),
    loginOverlayBackground: require('../assets/loginoverlaybackground.jpg'),
    drawerClose: require('../assets/drawerclose.svg').default,
    drawerOpen: require('../assets/draweropen.svg').default,
    cmLogoSVG: require('../assets/cmlogo.svg').default,
    // notificationIcon: require('../assets/notificationbing.svg').default,
    addItem: require('../assets/additem.svg').default,

    prashantgroup: require('../assets/prashantgroup.svg').default,

    // spaceDashboard: require('../assets/spacedashboard.svg').default,
    // description: require('../assets/description.svg').default,
    assignment: require('../assets/assignment.svg').default,
    aiicon: require('../assets/ai.svg').default,
    // article: require('../assets/article.svg').default,
    // analytics: require('../assets/analytics.svg').default,
    // people: require('../assets/people.svg').default,
    userright: require('../assets/userright.svg').default,

    // downlod: require('../assets/downlod.svg').default,
    refresh: require('../assets/refresh.svg').default,
    timeclock: require('../assets/timeclock.svg').default,
    // view: require('../assets/view.svg').default,
    viewslash: require('../assets/viewslash.svg').default,
    addsquare: require('../assets/addsquare.svg').default,
    datecalendar: require('../assets/datecalendar.svg').default,
    delete: require('../assets/delete.svg').default,
    documentupload: require('../assets/documentupload.svg').default,
    // edit: require('../assets/edit.svg').default,
    closesquare: require('../assets/closesquare.svg').default,
    ticksquare: require('../assets/ticksquare.svg').default,
    copy: require('../assets/copy.svg').default,
    savetick: require('../assets/savetick.svg').default,
    addtick: require('../assets/addtick.svg').default,

    newcomplaint: require('../assets/newcomplaint.svg').default,
    // pendingcomplaint: require('../assets/pendingcomplaint.svg').default,
    // assignedcomplaint: require('../assets/assignedcomplaint.svg').default,
    // rejectedcomplaint: require('../assets/rejectedcomplaint.svg').default,
    arrowsquaredown: require('../assets/arrowdown.svg').default,
    arrowsquareup: require('../assets/arrowup.svg').default,
    filtersquare: require('../assets/filtersquare.svg').default,
    // dollarsquare: require('../assets/dollarsquare.svg').default,
    // usersquare: require('../assets/usersquare.svg').default,

    // new icons
    companylogoWhite: require('../assets/companylogowhite.svg').default,
    spaceDashboard: require('../assets/dashboard.png'),
    dollarsquare: require('../assets/dollarsquare.png'),
    usersquare: require('../assets/usersquare.png'),
    analytics: require('../assets/analytics.png'),
    people: require('../assets/people.png'),
    article: require('../assets/article.png'),
    pendingcomplaint: require('../assets/document.png'),
    description: require('../assets/document.png'),
    rejectedcomplaint: require('../assets/document.png'),
    feedbackquestion: require('../assets/feedback.png'),
    prechecklist: require('../assets/prechecklist.png'),
    leavemanagement: require('../assets/leave.png'),
    feedbackicon: require('../assets/feedbackicon.png'),
    amcicon: require('../assets/amcicon.png'),
    announcement: require('../assets/announcement.png'),
    capaicon: require('../assets/capaicon.png'),
    downlod: require('../assets/download.png'),
    sortingarrow: require('../assets/sortingarrow.png'),
    addicon: require('../assets/addicon.png'),
    editicon: require('../assets/edit.png'),
    view: require('../assets/viewicon.png'),
    checkicon: require('../assets/checkicon.png'),
    calendar: require('../assets/calendar.png'),

    acceptreject: require('../assets/acceptreject.png'),
    allcomplaints: require('../assets/allcomplaints.png'),
    unassignedcomplaints: require('../assets/unassignedcomplaints.png'),
    announcementold: require('../assets/announcementold.png'),

    checkboxsquare: require('../assets/checkboxsquare.svg').default,
    notificationIcon: require('../assets/notificationicon.svg').default,
    modalclose: require('../assets/modalclose.svg').default,
    textsearchicon: require('../assets/textsearchicon.svg').default,
    documentuploadnew: require('../assets/document-upload-new.svg').default,


    profile: require('../assets/user-square.png'),
    setting: require('../assets/setting-2.png'),
    logout: require('../assets/logout.jpg'),
    userProfile: require('../assets/userProfile.svg').default,


    emailicon: require('../assets/emailicon.svg').default,
    departmenticon: require('../assets/departmenticon.svg').default,
    calendaricon: require('../assets/calendaricon.svg').default,
    telephoneicon: require('../assets/telephoneicon.svg').default,
    telephoneicon: require('../assets/telephoneicon.svg').default,
    addcircle: require('../assets/addcircle.svg').default,
    minuscirlce: require('../assets/minuscirlce.svg').default,
    leftarrow: require('../assets/leftarrow.svg').default,
    rightarrow: require('../assets/rightarrow.svg').default,

    closeCircle: require('../assets/close-square.png'),
    tickCircle: require('../assets/tick-square.png'),

    lastpageicon: require('../assets/lastpageicon.svg').default,
    nextpageicon: require('../assets/nextpageicon.svg').default,
    firstpageicon: require('../assets/firstpageicon.svg').default,
    prevpageicon: require('../assets/prevpageicon.svg').default,
}

export const Images = { ...commonImages }